import { render, staticRenderFns } from "./KETWidgetHinweis.vue?vue&type=template&id=a6f067d8&"
import script from "./KETWidgetHinweis.vue?vue&type=script&lang=js&"
export * from "./KETWidgetHinweis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports